import { useFocusOnAssembly } from '../hooks/useFocusOnAssembly';

// Component helps to place the hook under AbyssViewerContextProvider
export const FocusOnAssembly = () => {
  useFocusOnAssembly();

  return <></>;
};
